<template>
    <b-form-checkbox
        :checked="value"
        :state="input_state"
        v-bind="$attrs"
        v-on="inputListeners"
    ></b-form-checkbox>
</template>

<script>
import VuexInputFieldMixin from "./VuexInputFieldMixin";

export default {
    name: "OCheckBoxInput",
    mixins: [VuexInputFieldMixin(true)],
};
</script>

<style scoped></style>
